// extracted by mini-css-extract-plugin
module.exports = {"StockHoldersPage":"holders_StockHoldersPage__YWY9_"};